// extracted by mini-css-extract-plugin
module.exports = {"block":"IndustryComparisonListAlt_block__0GR6V","list":"IndustryComparisonListAlt_list___dEGK","noListText":"IndustryComparisonListAlt_noListText__gjqIq"};